import { BaseDto } from '@/shared/dtos/base-dto';
import { etiqueta } from './etiqueta';

export class Marketing extends BaseDto {
    public tipo_mensaje !: number;
    public asunto !: string;
    public mensaje !: string;
    public etiquetas!: etiqueta[];
} 
